export default "__VITE_ASSET__DinK824K__"